import {head, last} from 'ramda';

import {CommonAddressResponseBody} from '@dms/api/customer';
import {AuthAddressResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export const authAddressToAddressData = (address: AuthAddressResponseBody | Nullish) => {
  const streetName = address?.street?.split(' ').pop();
  const streetNameLength = address?.street?.split(' ').length ?? 0;
  const streetNumber = streetNameLength > 1 ? last(address?.street?.split(' ') ?? []) : '';
  const descriptiveNumber = streetNumber && head(streetNumber?.split('/'));
  const orientationNumber = streetNumber && last(streetNumber?.split('/'));
  const addressData: CommonAddressResponseBody = {
    street: streetName ?? '',
    descriptiveNumber: descriptiveNumber ?? null,
    orientationNumber: orientationNumber ?? null,
    city: address?.city ?? '',
    zip: address?.zipCode ?? '',
    state: address?.state ?? '',
    country: address?.country ?? '',
    addressComplement: null,
    prefix: null,
    district: null,
  };
  return addressData;
};
